import { FIRST_PAGE } from '@app/application/user-management/constants'
import { abort, getSignal } from '@app/adapters/abort'

export type QueryParam = string | (string | null)[]

export const toSortDirection = (param: QueryParam): 'asc' | 'desc' =>
  param === 'desc' ? 'desc' : 'asc'

export const toPage = (param: QueryParam): number => {
  const page = Number(param)

  return Number.isInteger(page) && page > 0 ? page : FIRST_PAGE
}

export const toSearch = (param: QueryParam): string | undefined =>
  typeof param === 'string' ? param.trim() || undefined : undefined

// Two clicks in a row leave two requests in flight and they can answer in
// either order. Starting a request cancels the one before it, and the returned
// check is how the older run tells the list has moved on without it.
export const startLatestRequest = (
  key: Parameters<typeof abort>[0],
  reason: string
): (() => boolean) => {
  abort(key, reason)

  const signal = getSignal(key)

  return () => signal?.aborted === true
}
